import Mapbox from 'index.vue';
import { BaseRasterLayer } from './baseRasterLayer';
export class HereMapsLayer extends BaseRasterLayer {
    constructor(mapboxInstance: InstanceType<typeof Mapbox>, satteliteView: boolean) {
        super(mapboxInstance, 'bottom'); 
        const tileUrl = `https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png8?style=` + (!satteliteView ? 'explore' : 'satellite') + `.day&apiKey=qG72dx8eH8kxNI9mjPfCQLK6-eQeI3aU4YS2v2j7IOs`;
        this.AddLayer('here', tileUrl, 25);
    }

    
}